import { DiContainerService } from './di-container-service.js';
export class AppDiContainerService extends DiContainerService {
    static instance = new AppDiContainerService();
    constructor() {
        super();
    }
}
//# sourceMappingURL=app-di-container-service.js.map